import { createFormData } from "./formData";
import * as Api from "service/index";

export const uploadFile = async (file) => 
  await Api.main.uploadFiles(createFormData(file)).then(res => res.filePath);